import * as React from 'react';
import styled from 'styled-components';

import { Typography } from '@material-ui/core';

import DateTime from '../../components/DateTime';
import { onFormatDate, onFormatUTCTime } from '../../utils/dateUtils';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1500px;
  color: white;
`;

interface IGeneralInfoProps {}

const GeneralInfo: React.FunctionComponent<IGeneralInfoProps> = (props) => {
  return (
    <Container>
      <Typography>
        SCALE: 28NM SYSTEM: <DateTime isLive onFormat={onFormatDate} />{' '}
        <DateTime isLive onFormat={onFormatUTCTime} /> LOCAL:{' '}
        <DateTime isLive onFormat={onFormatUTCTime} />
      </Typography>
    </Container>
  );
};

export default GeneralInfo;
